import styled from 'styled-components';

import { layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { CardContent } from '@prisjakt/ui/card';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

export const Media = styled.div``;

export const Summary = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${layout.measurements.spacingSmall};
`;

export const ReadMore = styled(Button)`
  color: ${p => p.theme.text.callToAction};
  width: 100%;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const TextBlock = styled.div`
  display: grid;
  grid-auto-flow: row;
  row-gap: ${layout.measurements.spacingSmall};

  span:last-of-type {
    p {
      margin-bottom: 0;
    }
  }
`;

export const Content = styled(CardContent)`
  > :not(:last-child) {
    margin-bottom: ${layout.measurements.spacingNormal};
  }
`;
